/** Date helpers for report windows. All values are local-date `YYYY-MM-DD` strings. */

function fmt(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/** Yesterday, relative to the viewer's local date. Daily reports use this for from and to. */
export function yesterday(today: Date = new Date()): string {
  const d = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  d.setDate(d.getDate() - 1);
  return fmt(d);
}

/**
 * The previous complete Monday–Sunday week, relative to the viewer's local date.
 * Ratchets by one week every Monday. E.g. today Wed 2022-06-22 -> { from: 2022-06-13, to: 2022-06-19 }.
 */
export function previousWeek(today: Date = new Date()): {
  from: string;
  to: string;
} {
  const d = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const daysSinceMonday = (d.getDay() + 6) % 7; // Mon=0 ... Sun=6
  const mondayThisWeek = new Date(d);
  mondayThisWeek.setDate(d.getDate() - daysSinceMonday);

  const from = new Date(mondayThisWeek);
  from.setDate(mondayThisWeek.getDate() - 7); // Monday of last week
  const to = new Date(from);
  to.setDate(from.getDate() + 6); // Sunday of last week

  return { from: fmt(from), to: fmt(to) };
}
